module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/not-found/not-found.component.scss
// module id = ./src/app/componentes/not-found/not-found.component.scss
// module chunks = main